<template>
  <div>
    <settings-card :config="config">
      <el-button
        type="text"
        @click="payApply">去设置</el-button>
    </settings-card>
    <customer-modal ref="modal" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SettingsCard from './settings-card.vue'
import CustomerModal from './customer-modal.vue'

export default {
  name: 'WarehouseCard',
  components: {
    SettingsCard,
    CustomerModal
  },
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    payApply() {
      this.$router.push('/customer-list')
      // this.$refs.modal.fetch({
      //   vendorId: this.userInfo.vendorId
      // })
    }
  }
}
</script>
